module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/banner_beach_photo-ade43c52db09d7fd993ef89e86df74da.png";